import LiteraryAgencyFormPage from "./LiteraryAgencyFormPage";

const LiteraryAgencyCreate = () => {
  return (
    <LiteraryAgencyFormPage></LiteraryAgencyFormPage>
  )
}

export default LiteraryAgencyCreate;